
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import dataLack from '@/components/dataLack'
import {


invoiceCheckStatus,
invoiceReimbursementStatus,
invoiceExtractStatus, //抽取状态
discernStatus,
tenantCode,
SignFlag,
SignFlagCN,
extractFlagStatus,
extractFlagStatusCN,
} from "@/common/js/const";

import {operateInvoice,tip,companySource} from '@/common/js/common'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {

directives: {
TransferDom
},
components: {
Group,
Previewer,
XDialog,
Cell,

CellBox,
XHeader,

Box,
XButton,
CellFormPreview,
Actionsheet,
XTable,
dataLack
},
data() {
return {
source: '',
allowRecheckException: false,
allowQueryOccupy: false,
invoiceReimbursementStatus: invoiceReimbursementStatus,
discernStatus: discernStatus,
invoiceExtractStatus: invoiceExtractStatus,
invoiceCheckStatus: invoiceCheckStatus,
SignFlag: SignFlag,
SignFlagCN: SignFlagCN,
extractFlagStatus:extractFlagStatus,
extractFlagStatusCN: extractFlagStatusCN,


showMore: false,
showMoreBtn: true,

shareMenus: {




edit: this.$t("编辑"),
delete: '<span class="text-error">' + this.$t("删除") + "</span>"
},
moredocumentTypeObj: {
50001010: '火车票',
50001011: '出租车票',
50001009: '行程单',
50001013: '定额发票',
50001001: '机动车发票',
50001016: '客运汽车票',
50001015: '二手车票',
40001001: '卷票',
20001001: '普票',
20001002: '普票',
10001001: '专票',
10001002: '专票',
30001001: '电子普票',
30001003: '电子普票',
50001014: '过路费',
},

showInfoForMissing: false,
showCheckResultDialog: false,
showSellerDetail: false,
showBuyerDetail: false,
showGoodsDetail: false,
showWorkFlow: false,
checkResult: "",
showReturned: false,
returnedMsg: '',
imageSlide1: [
{
src: "",
msrc: "",
alt: "",
title: "",
w: 600,
h: 400,
pid: "image-one"
}
],
reimburseList: [],

invoiceInfo: {
documentType: "20001001",
documentTypeName: "增值税普通发票",
groupFlag: "",

thumbnail: "",
savedByOther: 0, //是否已被他人保存
buyer: {
name: "",
taxNumber: "",
bank: "",
bankAccount: "",
address: "",
tel: ""
},
buyerFormDetail: [




















],
seller: {
name: "",
taxNumber: "",
bank: "",
bankAccount: "",
address: "",
tel: ""
},
sellerFormDetail: [




















],
goods: "", //地下车库使用费等商品
goodsFormDetail: [
{
label: this.$t("名称"),
value: this.$t("金额/税率")
}
],
labels: [],
faPiaoHaoMa: []
},
nInvoiceInfo:{},
};
},
created() {

let source = localStorage.getItem('source');
this.source = source;
},
activated() {
let source = localStorage.getItem('source');
this.source = source;
},
deactivated() {},
beforeRouteLeave(to, from, next) {
document.getElementById("app_body").style["background-color"] = "#fbf9fe";
document.getElementById("app_html").style["background-color"] = "#fbf9fe";
next();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {





isHISUN() {
return this.source === "HISUN";
},
isHISUNORHANHUI() {
return this.source === "HISUN" || this.source === 'futureland';
},
isSuccessOrFailed() {
var $self = this;
try {
return (
$self.invoiceInfo.checkStatus === invoiceCheckStatus.checkSuccess ||
$self.invoiceInfo.checkStatus === invoiceCheckStatus.checkSuccess + '' ||
$self.invoiceInfo.checkStatus === invoiceCheckStatus.checkFailed ||
$self.invoiceInfo.checkStatus === invoiceCheckStatus.checkFailed + ''
)
} catch (error) {
return false;
}
},

isZengZhiShuiPiao() {
var $self = this;
try {
return (
$self.invoiceInfo.documentType.indexOf("1000") == 0 ||
$self.invoiceInfo.documentType.indexOf("2000") == 0 ||
$self.invoiceInfo.documentType.indexOf("3000") == 0 ||
$self.invoiceInfo.documentType.indexOf("4000") == 0 ||
$self.invoiceInfo.documentType.indexOf("50001001") == 0 ||
$self.invoiceInfo.documentType.indexOf('50001017') == 0 ||
($self.invoiceInfo.documentType.indexOf('50001009') == 0 && $self.invoiceInfo.verifyFlag != '') 
);
} catch (error) {
return false;
}
},

isFeiJiHuoCheChuZuChe() {
var $self = this;
try {
return (
$self.invoiceInfo.documentType.indexOf("50001010") == 0 ||
$self.invoiceInfo.documentType.indexOf("50001009") == 0 ||
$self.invoiceInfo.documentType.indexOf("50001011") == 0
);
} catch (error) {
return false;
}
},

isOtherPiao() {
var $self = this;
try {
return (
$self.invoiceInfo.documentType.indexOf("90009999") == 0 ||
$self.invoiceInfo.documentType.indexOf("50009999") == 0 ||
$self.invoiceInfo.documentType.indexOf("90001006") == 0
);
} catch (error) {
return false;
}
}
},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;
document.getElementById("app_body").style["background-color"] = "#2b88d8";
document.getElementById("app_html").style["background-color"] = "#2b88d8";
var __id = $self.$route.params.id;
$self.loadData(__id);
$self.$webapi.getUserInfo().then(res => {
if (res.data.status == 1) {
var resData = res.data.result;
this.allowRecheckException = resData.userInfoExt.allowRecheckException;
this.allowQueryOccupy = resData.userInfoExt.allowQueryOccupy;
if(this.allowRecheckException) {
this.shareMenus = {recheck: this.$t("发票校验"), ...this.shareMenus};
}
}
});
},
methods: {
formatCheckStatus2(value, $t) {
if (!value) return '';
var rel = '';
switch (value) {
case invoiceCheckStatus.checkSuccess:
case invoiceCheckStatus.checkSuccess + '':
rel = $t('查看验真结果');
break;
case invoiceCheckStatus.checkFailed:
case invoiceCheckStatus.checkFailed + '':
rel = $t('查看验真失败原因');
break;

case invoiceCheckStatus.checking:
case invoiceCheckStatus.checking + '':
rel = $t('查看验真结果');
break;

default:
case invoiceCheckStatus.notCheck:
case invoiceCheckStatus.notCheck + '':
rel = $t('查看验真结果');
break;
}
return rel;
},
formatCheckStatus3(value) {
if (!value) return '';
var rel = '';
switch (value) {
case invoiceCheckStatus.checkSuccess:
case invoiceCheckStatus.checkSuccess + '':
rel = 'document-mark success';
break;
case invoiceCheckStatus.checkFailed:
case invoiceCheckStatus.checkFailed + '':
rel = 'document-mark error';
break;

case invoiceCheckStatus.checking:
case invoiceCheckStatus.checking + '':
rel = 'document-mark primary';
break;

default:
case invoiceCheckStatus.notCheck:
case invoiceCheckStatus.notCheck + '':
rel = 'document-mark';
break;
}
return rel;
},
goOccupy() {
this.$router.push({name:'InvoiceOccupy',params:{id: this.invoiceInfo.__id}})
},
userdTip(){
let source = companySource()
let markText = source == 'futureland' ? '采集' : '占用'
return `此发票已被他人${markText}，无法报销`
},
pageGoBack() {
var $self = this;














this.$router.push('/invoice/index')
},
/**加载发票信息 */
loadData(invoiceId) {
var $self = this;
$self.$webapi
.oneInvoice({
invoiceId: invoiceId
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
$self.nInvoiceInfo = resData
$self.invoiceInfo = {
__id: resData.invoiceId,
extractFlag: resData.extractFlag,
verifyFlag: resData.verifyFlag,
tInvoiceExtendObj: resData.tInvoiceExtendObj,

invoiceDate: $self.$formatDateTime3(
resData.paperDrewDate,
"YYYY-MM-DD"
),
totalTaxAmount:
"￥" +
resData.amountWithTax +
(resData.amountWithTax == resData.amountWithoutTax &&
resData.amountWithTax != 0
? "<small class='text-muted'>(" +
$self.$t("不含税") +
")</small>"
: ""),

savedByOther:
resData.uniqueFlag == 0 || resData.uniqueFlag == "0", //uniqueFlag 1属于自己  0 已被他人保存
extractStatus: resData.extractFlag,

tags: resData.ext3,
redFlag: resData.redFlag,
checkStatus: resData.verifyFlag,
signFlag: resData.signFlag,

discernStatus: resData.discernFlag,

reimbursement: resData.processFlag,
uniqueFlag: resData.uniqueFlag,
invoiceFlag: resData.invoiceFlag,
hasTitle: resData.hasTitle, //抬头维护状态

documentType: resData.documentType,
documentTypeName: resData.documentTypeName || "票据文档",
groupFlag: resData.groupFlag,

thumbnail: resData.imgUrl, //图片地址
note: resData.ext2,
invoiceNote: resData.remark,
buyer: {
name: resData.purchaserName,
taxNumber: resData.purchaserTaxNo,
bank: resData.purchaserBankName,
bankAccount: resData.purchaserBankAccount,
address: resData.purchaserAddress,
tel: resData.purchaserTel
},
buyerFormDetail: [
{
label: this.$t("名称"),
value: resData.purchaserName
},
{
label: this.$t("税号"),
value: resData.purchaserTaxNo
},
{
label: this.$t("开户行"),
value: resData.purchaserBankName
},
{
label: this.$t("银行账号"),
value: resData.purchaserBankAccount
},
{
label: this.$t("电话"),
value: resData.purchaserTel
},
{
label: this.$t("地址"),
value: resData.purchaserAddress
}
],
seller: {
name: resData.sellerName,
taxNumber: resData.sellerTaxNo,
bank: resData.sellerBankName,
bankAccount: resData.sellerBankAccount,
address: resData.sellerAddress,
tel: resData.sellerTel
},
sellerFormDetail: [
{
label: this.$t("名称"),
value: resData.sellerName
},
{
label: this.$t("税号"),
value: resData.sellerTaxNo
},
{
label: this.$t("开户行"),
value: resData.sellerBankName
},
{
label: this.$t("银行账号"),
value: resData.sellerBankAccount
},
{
label: this.$t("电话"),
value: resData.sellerTel
},
{
label: this.$t("地址"),
value: resData.sellerAddress
}
],
extInfoFormDetail: [],
goods: "",
goodsFormDetail: [
{
label: this.$t("名称"),
value: this.$t("金额/税率")
}
],
labels: [],
faPiaoHaoMa: [
{
label: this.$t("发票日期"),
value: $self.$formatDateTime3(
resData.paperDrewDate,
"YYYY-MM-DD"
)
},
{
label: this.$t("发票号码"),
value: resData.invoiceNo
},
{
label: this.$t("发票代码"),
value: resData.invoiceCode
},
{
label: this.$t("校验码"),
value: resData.checkCode
}
],
timeAgo: 999999999,
__data: resData
};

$self.loadTags(invoiceId);
$self.loadCheckResult(invoiceId);

var nowTime = new Date().getTime();

$self.invoiceInfo.timeAgo = Math.abs(
new Date(
$self.$formatDateTime2(
resData.createTime,
"YYYY/MM/DD HH:mm:ss"
)
).getTime() - nowTime
);


$self.imageSlide1[0].src = resData.imgUrl;
$self.imageSlide1[0].msrc = resData.imgUrl;


var temp_img_url = resData.imgUrl;

var temp_img = new Image();

temp_img.src = temp_img_url;

if (temp_img.complete) {


$self.imageSlide1[0].h = temp_img.height;
$self.imageSlide1[0].w = temp_img.width;
} else {

temp_img.onload = function() {


$self.imageSlide1[0].h = temp_img.height;
$self.imageSlide1[0].w = temp_img.width;
};
}

if (resData.extInfo != "") {
try {
var tempExtInfoJSON = JSON.parse(resData.extInfo);
$self.invoiceInfo.extInfoFormDetail = tempExtInfoJSON.map(
function(item) {
return {
label: item.displayName,
value: item.value
};
}
);
} catch (error) {
console.log(error);
$self.invoiceInfo.extInfoFormDetail = [];
}
}
let infos = resData.businessInfo?JSON.parse(resData.businessInfo):[];
if(resData.groupFlag == "deppon"&& infos && infos.length > 0){
if(resData.processFlag===invoiceReimbursementStatus.reimbursement){
var resultList = [];
infos.forEach(function(itt) {
var valueStr = itt.value;
if (valueStr.indexOf(",") > 0) {
var valueArr = valueStr.split(",");
var object = {};
object.updateDate = valueArr[0];
object.workFlow = valueArr[1];
object.amount = "￥" + valueArr[2];
resultList.push(object);
}
});
$self.reimburseList = resultList;
$self.showWorkFlow = true;
}else if(resData.processFlag===invoiceReimbursementStatus.returned){
$self.returnedMsg = infos[0].value;
$self.showReturned = true;
}
}

resData.details.map(function(item) {
var tempName = $self.$options.filters.formatTitle(
item.cargoName,
12
);
$self.invoiceInfo.goodsFormDetail.push({
label: tempName,
value:
"￥" +
item.amountWithTax +
" - " +
item.taxRate +
"%" 
});
});
if (resData.details.length > 0) {
$self.invoiceInfo.goods +=
$self.$options.filters.formatTitle(
resData.details[0].cargoName,
8
) +
"等" +
resData.details.length +
"种类目";
}



if (
$self.invoiceInfo.invoiceNo == "" &&
$self.invoiceInfo.invoiceCode == "" &&
$self.invoiceInfo.extInfo == "" &&
$self.invoiceInfo.paperDrewDate == ""








) {
$self.showInfoForMissing = true;
}

}
});
},


showReimbursement(groupFlag) {
var $self = this;
if (groupFlag == "futureland") {
return false;
} else {
return true;
}
},

showHasTitle(groupFlag) {
if (groupFlag == tenantCode.shenhua) {
return true;
} else {
return false;
}
},

/**加载验真结果 */
loadCheckResult(invoiceId) {
var $self = this;

$self.$webapi
.oneInvoiceCheckResult({
invoiceId: invoiceId
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
$self.checkResult = resData.verifyRemark;
} else {
$self.checkResult = "";
}
});
},
/**加载发票票据标签 */
loadTags(invoiceId) {
var $self = this;
$self.$webapi
.listTagByInvoice({
invoiceId: invoiceId
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
var tempLabels = [];
resData.map(function(item) {
if (item.status == 1) {
tempLabels = tempLabels.concat([
{
label: item.labelName,
value: item.id
}
]);


}
});
$self.invoiceInfo.labels = tempLabels;
}
});
},

shareMenusClick(key, item) {
var $self = this;

if (key == "toEmail") {
$self.shareToEmail();
} else if (key == "copyLink") {
$self.copyLink();
} else if (key == "edit") {


















if(!operateInvoice($self.nInvoiceInfo,'edit')){
return false
}

localStorage.setItem('detail','detail')
let path = "/invoice/moreUpdate/" + $self.invoiceInfo.__id + '/' + $self.invoiceInfo.documentType
localStorage.setItem('forwardPath',this.$route.path)
$self.$router.push(path);
} else if (key == "delete") {














if(!operateInvoice($self.nInvoiceInfo,'del')){
return false
}

$self.$vux.confirm.show({
title: this.$t("提示"),
content: this.$t("删除警告"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
onCancel() {},
onConfirm(newVal) {
$self.$webapi
.deleteInvoice({
invoiceId: $self.invoiceInfo.__id
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.$vux.toast.show({
text: $self.$t("操作成功"),
type: "text"
});
setTimeout(function() {
$self.$router.push({
path: "/invoice/index",
query: { p_refresh: "2" } 
});
}, 300);
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: "text"
});
}
});
}
});
} else if (key == "recheck") {
$self.$webapi
.recheckInvoiceException({
invoiceId: $self.invoiceInfo.__id
})
.then(res => {
if (res.data.status == 1) {
$self.$vux.toast.show({
text: res.data.msg,
type: "text"
});
setTimeout(() => {
location.reload();
}, 1500);
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: "text"
});
}
});
}
},

copyLink() {
var $self = this;
$self.$vux.alert.show({
title: this.$t("长按下面文字复制"),
content: "",
onShow() {},
onHide() {}
});
},

shareToEmail() {
var $self = this;
$self.$vux.confirm.prompt(this.$t("请输入收票邮箱"), {
title: this.$t("发到邮箱"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
inputAttrs: {
type: "email"
},
onShow() {


},
onCancel() {},
onConfirm(newVal) {
if (newVal) {
$self.$clog("发送到" + newVal);
}
}
});
},

linkToPicture() {
var $self = this;

if ($self.invoiceInfo.thumbnail) {

$self.$router.push({
path: "/invoice/photoviewer/" + $self.invoiceInfo.__id
});



} else {
$self.$vux.toast.show({
text: $self.$t("票据影像不存在"),
type: "text"
});
}
},
toTag(id){
localStorage.setItem('forwardPath',this.$route.path)
this.$router.push(`/invoice/tag/${id}`)
}
}
};
